export const EDITOR_BYLINE = 'Editor';
const API='https://standard.gm/wp-json/wp/v2';
const fields='id,slug,date,date_gmt,modified,title,excerpt,content,author,categories,featured_media,link,_links,_embedded,standard_focal_point,standard_authors';
import { parseDocument } from 'htmlparser2';
import { textContent, findAll } from 'domutils';
import serialize from 'dom-serializer';
export const text = html => textContent(parseDocument(html || '')).trim();
export function safeContent(html, sponsored = false) {
 const doc = parseDocument(html || '');
 const allowed = new Set(['p','br','strong','b','em','i','u','a','ul','ol','li','h2','h3','h4','h5','h6','blockquote','figure','figcaption','img','table','thead','tbody','tr','td','th','hr','div','span']);
 const blocked = new Set(['script','style','iframe','object','embed','form','input','button','svg','math','link','meta']);
 function clean(nodes) {
  return nodes.flatMap(el => {
   if(el.type === 'text') return [el];
   if(!el.name || blocked.has(el.name)) return [];
   el.children = clean(el.children || []);
   if(!allowed.has(el.name)) return el.children;
   const attrs = {};
   for(const [name,value] of Object.entries(el.attribs || {})) {
    if(!['href','src','alt','title','colspan','rowspan','width','height'].includes(name)) continue;
    if(name === 'href' || name === 'src') { try { const url = new URL(value, 'https://standard.gm/'); if(['http:','https:'].includes(url.protocol)) attrs[name] = url.href; } catch {} }
    else attrs[name] = value;
   }
   if(el.name === 'img') attrs.loading = 'lazy';
   if(el.name === 'a') { const external=attrs.href && new URL(attrs.href).hostname !== 'standard.gm'; attrs.rel = 'noopener noreferrer'+(sponsored && external ? ' sponsored' : ''); }
   el.attribs = attrs;
   return [el];
  });
 }
 doc.children = clean(doc.children);
 return serialize(doc.children);
}
export function mapPost(p) {
 const categories=(p._embedded?.['wp:term']?.[0]||[]);
 const author=p._embedded?.author?.[0];
 const media=p._embedded?.['wp:featuredmedia']?.[0];
 const paid=categories.some(c=>['advertisement','sponsored-content','sponsored'].includes(c.slug));
 const html=safeContent(p.content?.rendered,paid);
 const doc=parseDocument(html);
 const body=findAll(e=>['p','h2','h3','li','blockquote'].includes(e.name),doc.children).map(e=>textContent(e).trim()).filter(Boolean);
 const dateIso=(p.date_gmt||p.date)+'Z';
 const records = (Array.isArray(p.standard_authors) ? p.standard_authors : author && author.id !== 5 ? [author] : []).filter(a=>a?.id && a.id !== 5).map(mapAuthor);
 const primary = records[0] || {id:5,name:EDITOR_BYLINE,avatar:null,has_avatar:false};

 return {hasFullContent: Boolean(p.content?.rendered),id:p.slug,wpId:p.id,focalPoint:p.standard_focal_point || null,title:text(p.title?.rendered),excerpt:text(p.excerpt?.rendered),kicker:text(categories[0]?.name)||'The Standard',category:categories[0]?.slug||'gambia-news',categorySlugs:categories.map(c=>c.slug),date:new Intl.DateTimeFormat('en-GB',{day:'numeric',month:'long',year:'numeric',timeZone:'Africa/Banjul'}).format(new Date(dateIso)),dateIso,modifiedIso:(p.modified_gmt||p.modified||p.date_gmt||p.date)+'Z',seoImage:media?.source_url||null,timestamp:new Date(dateIso).getTime(),img:media?.media_details?.sizes?.large?.source_url||media?.source_url||'/story-placeholder.svg',imgAlt:text(media?.alt_text)||text(p.title?.rendered),authors:records,author:records.length?records.map(a=>a.name).join(' and '):EDITOR_BYLINE,authorRecord:primary,body,bodyHtml:html,sourceUrl:p.link};
}
async function get(path){const response=await fetch(API+path,{signal:AbortSignal.timeout(15000)});if(!response.ok)throw new Error('WordPress '+response.status);return response.json();}
export async function fetchWordPressEdition() {
 const wanted=['sports','politics','opinions','bantaba','gambia-news','advertisement','biography','daily-poem','gossip','history','short-story','sister-speaks','society','the-hub'];
 const categories=await get('/categories?per_page=100&hide_empty=true&slug='+wanted.join(','));
 const paths=['/posts?per_page=60&_embed=1&_fields='+fields,...categories.filter(c=>wanted.includes(c.slug)).map(c=>'/posts?per_page=15&categories='+c.id+'&_embed=1&_fields='+fields)];
 const groups=await Promise.all(paths.map(get));return {categories,posts:[...new Map(groups.flat().map(p=>[p.id,p])).values()]};
}

export async function fetchArchive({ category, author, search, offset = 0, perPage = 12 } = {}) {
 const params = new URLSearchParams({per_page:String(perPage),offset:String(offset),_embed:'1'});
 if (category && category !== 'all-news') {
  const categories = await get('/categories?slug='+encodeURIComponent(category));
  if (!categories[0]) return {posts:[],total:0};
  params.set('categories',categories[0].id);
 }
 if (author) params.set('standard_author',author);
 if (search) params.set('search',search);
 const r = await fetch(API+'/posts?'+params,{signal:AbortSignal.timeout(20000)});
 if (!r.ok) throw new Error('Archive unavailable');
 return {posts:await r.json(),total:Number(r.headers.get('X-WP-Total') || 0)};
}
export async function fetchPostBySlug(slug) { const posts=await get('/posts?slug='+encodeURIComponent(slug)+'&_embed=1'); return posts[0] || null; }
export async function fetchWordPressAuthor(value) {
 const response=await fetch('https://standard.gm/wp-json/standard/v1/authors/'+encodeURIComponent(value),{signal:AbortSignal.timeout(20000)});
 if(response.ok) return response.json();
 if(response.status!==404)throw new Error('Author unavailable');
 if (/^\d+$/.test(value)) return get('/users/'+value);
 const list=await get('/users?slug='+encodeURIComponent(value));return list[0] || null;
}
export function mapAuthor(author) {
 const profile=author.mpp_avatar;
 const profileUrl=typeof profile==='string'?profile:profile?.['300']||profile?.['150']||profile?.['96']||profile?.full;
 // Only a configured profile image is eligible; never substitute a story image.
 const candidate=profile?.errors ? null : profileUrl;
 const avatar=typeof candidate==='string'&&/^https?:\/\//.test(candidate)?candidate:null;
 return {id:author.id,name:text(author.name),bio:text(author.description),avatar,has_avatar:Boolean(avatar)};
}

export function splitArticleBody(html) {
 const nodes = parseDocument(html || '').children;
 let seen = 0;
 function split(list) {
  const before = [], after = [];
  for (const node of list) {
   if (seen >= 3) { after.push(node); continue; }
   if (node.name === 'p') { seen++; before.push(node); continue; }
   if (node.children?.length) {
    const [a,b] = split(node.children);
    if(a.length) before.push({...node, children:a});
    if(b.length) after.push({...node, children:b});
   } else before.push(node);
  }
  return [before,after];
 }
 const [a,b] = split(nodes);
 return [serialize(a),serialize(b)];
}
